
/**
 * js模拟键盘点击事件 例:fireKeyEvent(input元素, 'keydown', 13)
 * @param param.el dom元素
 * @param param.evtType 事件类型
 * @param param.keyCode 键盘code
 */

// @ts-nocheck
export function fireKeyEvent(el: HTMLElement, evtType: string, keyCode: number) {
  var doc = el.ownerDocument,
    win = doc.defaultView || doc.parentWindow,
    evtObj
  if (doc.createEvent) {
    if (win.KeyEvent) {
      evtObj = doc.createEvent('KeyEvents')
      evtObj.initKeyEvent(
        evtType,
        true,
        true,
        win,
        false,
        false,
        false,
        false,
        keyCode,
        0
      )
    } else {
      evtObj = doc.createEvent('UIEvents')
      Object.defineProperty(evtObj, 'keyCode', {
        get: function () {
          return this.keyCodeVal
        },
      })
      Object.defineProperty(evtObj, 'which', {
        get: function () {
          return this.keyCodeVal
        },
      })
      evtObj.initUIEvent(evtType, true, true, win, 1)
      evtObj.keyCodeVal = keyCode
      if (evtObj.keyCode !== keyCode) {
        console.log(
          'keyCode ' + evtObj.keyCode + ' 和 (' + evtObj.which + ') 不匹配'
        )
      }
    }
    el.dispatchEvent(evtObj)
  } else if (doc.createEventObject) {
    evtObj = doc.createEventObject()
    evtObj.keyCode = keyCode
    el.fireEvent('on' + evtType, evtObj)
  }
}
